"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionAndRecipeFragment = exports.sectionAndRecipeNameFragment = exports.justSectionFragment = void 0;
const client_1 = require("@apollo/client");
const recipeName_1 = require("../../recipe/fragments/recipeName");
const recipePreviewFragment_1 = require("../../recipe/fragments/recipePreviewFragment");
exports.justSectionFragment = client_1.gql `
  fragment justSection on Section {
    __typename
    id
    name
    position
    owner
  }
`;
exports.sectionAndRecipeNameFragment = client_1.gql `
  fragment sectionAndRecipeName on Section {
    ...justSection
    recipes {
      ...recipeName
    }
  }
  ${exports.justSectionFragment}
  ${recipeName_1.recipeNameFragment}
`;
exports.sectionAndRecipeFragment = client_1.gql `
  fragment sectionAndRecipe on Section {
    ...justSection
    recipes {
      ...RecipePreview
    }
  }
  ${exports.justSectionFragment}
  ${recipePreviewFragment_1.recipePreviewFragment}
`;
//# sourceMappingURL=sectionAndRecipeName.js.map